import ListingsRoutingResolver from './ListingRoutingResolver';

class PurInvoiceListingResolver extends ListingsRoutingResolver {
    constructor() {
        super();
        this.key = 'purchaseinvoices';
    }
}

export default PurInvoiceListingResolver;
